import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  OnInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

/**
 * Componente para mostrar un mensaje de acceso denegado
 * cuando un usuario no tiene permiso para ver una página
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-access-denied',
  imports: [AppTranslationPipe, ButtonModule],
  template: `
    <div class="bg-gray-100 flex items-center justify-center h-screen">
      <div class="bg-white p-8 rounded-lg shadow-lg text-center max-w-lg">
        <h1 class="text-4xl font-bold text-red-600 mb-4">
          {{ 'security.access-denied' | translate }}
        </h1>
        <p class="text-gray-700 mb-4">
          {{ 'security.access-denied-message' | translate }}
        </p>
        @if (errorCode()) {
          <p class="text-sm text-gray-500 mb-2">
            <span class="font-semibold">Código:</span> {{ errorCode() }}
          </p>
        }
        @if (errorDescription()) {
          <p class="text-sm text-gray-500 mb-4">
            <span class="font-semibold">Detalle:</span> {{ errorDescription() }}
          </p>
        }
        <p-button
          icon="pi pi-home"
          [label]="'security.back-option-message' | translate"
          styleClass="w-full sm:w-auto min-h-[44px]"
          (onClick)="goHome()"
        />
      </div>
    </div>
  `,
  styles: ``
})
export class AccessDeniedComponent implements OnInit {
  readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  errorCode = signal<string | null>(null);
  errorDescription = signal<string | null>(null);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.errorCode.set(params['code'] || null);
      this.errorDescription.set(params['description'] || null);
    });
  }

  /** Lleva al usuario al Home (raíz de la app, que redirige al dashboard). */
  goHome(): void {
    this.router.navigate(['/']).catch((err) => console.error(err));
  }
}
